import React from 'react';


export default () => (
  <div className="default-configurations">
    <p>
      <span className="filename-template-heading">
        Default Configurations
      </span>
      <br />
      <b>
        If you choose not to customize your folder and file formats, we will use the
        following defaults:
      </b>
    </p>
    <p className="subtext">
      Folders will be created on the service as follows: CourtDrive/&#123;case number - case name&#125;
      <br />
      Files will be named as follows: court-citation_case_number_docket-entry-number.pdf
    </p>
  </div>
);




// WEBPACK FOOTER //
// ./src/Integrations/connections/DefaultConfigurations.jsx